<div class="modal-overlay">
    <div class="modal-window-card">
        <div class="modal-header-simple">
            <div>
                <h2 class="modal-heading-text">Extend link expiry</h2>
                <p class="modal-subheading-text">{{ data.linkName || 'Assessment Link' }}</p>
            </div>
            <button class="close-btn-ghost" (click)="closeDialog()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <div class="modal-body-scrollable">
            <div *ngIf="isExpired()" class="expired-alert">
                <div class="alert-title">This link has expired</div>
                <div class="alert-desc">Expired on {{ data.currentExpiry | date: 'MMM d, yyyy, h:mm a' }}</div>
            </div>

            <div class="quick-extend-section">
                <label class="section-label">Quick extend</label>
                <div class="quick-extend-buttons">
                    <button type="button" (click)="quickExtend(1)" 
                        class="quick-extend-btn"
                        [ngClass]="{'active': selectedQuickExtend === 1}">+1 day</button>
                    
                    <button type="button" (click)="quickExtend(7)" 
                        class="quick-extend-btn"
                        [ngClass]="{'active': selectedQuickExtend === 7}">+7 days</button>
                    
                    <button type="button" (click)="quickExtend(30)" 
                        class="quick-extend-btn"
                        [ngClass]="{'active': selectedQuickExtend === 30}">+30 days</button>
                </div>
            </div>

            <div class="form-group mb-0 date-picker-group">
                <label class="section-label">Or pick a date & time</label>
                <input type="datetime-local" [(ngModel)]="newExpiryDate" (ngModelChange)="selectedQuickExtend = null" [min]="minExpiryDate" class="form-input-styled">
            </div>

            <div *ngIf="newExpiryDate" class="new-expiry-info">
                <div class="info-title">New expiry</div>
                <div class="info-value">{{ newExpiryDate | date: 'MMM d, yyyy, h:mm a' }}</div>
            </div>
        </div>

        <div class="modal-footer-flex">
            <button class="btn-outline-ghost" (click)="closeDialog()">Cancel</button>
            <button class="btn-primary-purple-gradient d-flex align-items-center gap-2" (click)="extendExpiry()"
                [disabled]="isExtending || !isValid">
                <span *ngIf="isExtending" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                {{ isExtending ? 'Updating...' : 'Extend link' }}
            </button>
        </div>
    </div>
</div>
